import { render } from "./productList.vue?vue&type=template&id=52c2d16d&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"

import "./productList.vue?vue&type=style&index=0&id=52c2d16d&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c2d16d"]])

export default __exports__